/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { QuestionChangesControllerFindAllQueryResponse, QuestionChangesControllerFindAllQueryParams, QuestionChangesControllerFindAll401, QuestionChangesControllerFindAll403 } from "../../models/checklistsController/QuestionChangesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { questionChangesControllerFindAll } from "../../clients/checklistsService/questionChangesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const questionChangesControllerFindAllQueryKey = (params: QuestionChangesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-question-changes'
}, ...(params ? [params] : [])] as const;
export type QuestionChangesControllerFindAllQueryKey = ReturnType<typeof questionChangesControllerFindAllQueryKey>;
export function questionChangesControllerFindAllQueryOptions(params?: QuestionChangesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = questionChangesControllerFindAllQueryKey(params);
  return queryOptions<QuestionChangesControllerFindAllQueryResponse, ResponseErrorConfig<QuestionChangesControllerFindAll401 | QuestionChangesControllerFindAll403>, QuestionChangesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return questionChangesControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List checklist question change flags
 * {@link /api/v1/checklist-question-changes}
 */
export function useQuestionChangesControllerFindAll<TData = QuestionChangesControllerFindAllQueryResponse, TQueryData = QuestionChangesControllerFindAllQueryResponse, TQueryKey extends QueryKey = QuestionChangesControllerFindAllQueryKey>(params?: QuestionChangesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<QuestionChangesControllerFindAllQueryResponse, ResponseErrorConfig<QuestionChangesControllerFindAll401 | QuestionChangesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? questionChangesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...questionChangesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<QuestionChangesControllerFindAll401 | QuestionChangesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}